import React from 'react';
import { Flex, Typography } from 'antd';
import moment from 'moment';
import TransactionListItem from './TransactionListItem';
import { Transaction } from '../model/types';
import { TransactionAmountPresentation } from '../lib/transactionAmountPresentation';

export type TransactionItem = {
  date: string;
  transactions: Transaction[];
};

type TransactionsListProps = {
  transactions: Record<string, Transaction[]>;
  onClickTransaction: (transaction: Transaction) => void;
  amountPresentation?: TransactionAmountPresentation;
};

const TransactionsList: React.FC<TransactionsListProps> = ({
  transactions,
  onClickTransaction,
  amountPresentation = 'default',
}) => {
  const renderHeader = (date: string) => {
    return <Typography.Text strong>{moment(date, 'DD-MM-YYYY').format('LL')}</Typography.Text>;
  };

  const renderTransactionItem = (transaction: Transaction) => {
    return (
      <TransactionListItem
        key={transaction.id}
        transaction={transaction}
        onClick={onClickTransaction}
        amountPresentation={amountPresentation}
      />
    );
  };

  return (
    <Flex vertical>
      {Object.entries(transactions).map(([date, transactions]) => (
        <Flex key={date} vertical gap={16}>
          {renderHeader(date)}
          <Flex vertical>
            {transactions.map((transaction) => renderTransactionItem(transaction))}
          </Flex>
        </Flex>
      ))}
    </Flex>
  );
};

export default TransactionsList;
